<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Request of Payment Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
            <b-col lg="8">
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
                </b-input-group>
                <b-row>
                    <b-col lg="4">      
                        <b-input-group>
                            <b-input-group-prepend><label>Payment Method</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenis" :plain="true" :options="jenisPaym" :state="!$v.model.jenis.$error"></b-form-select>                              
                        </b-input-group>
                    </b-col>
                    <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>Payment To</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Payment To</span></b-input-group-prepend>
                        <b-form-input  v-model="model.terimadari" :state="!$v.model.terimadari.$error"></b-form-input>
                    </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row >
                    <b-col lg="7" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">
                        <b-input-group >
                            <b-input-group-prepend><label>Cheque/Giro No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor_cek" ></b-form-input>
                            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Cq/Giro Date</span></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_giro" type="date" ></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Due/Efective Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_terima" type="date"  ></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>             
                <b-row>
                    <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow=true" :state="!$v.model.kodebank.$error"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="lkuBankaccountShow=true">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                            </b-input-group-append>
                        </b-input-group>

                    </b-col>   
                    <b-col lg="5" v-if="(bankOnly=='1')">                            
                            <b-input-group >
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
                            </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row>
                    <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.valas_out" :precision="2" :state="!$v.model.valas_out.$error" v-b-tooltip.hover title="INCLUDE Bank Charges"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><span class="p-2">Bank Charges</span></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.bcharge" :precision="2"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Exch. Rate {{model.matauang || ''}}</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6"></my-number>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4">
                <v-dim :model="model" :key="updateDimHdr"></v-dim>
            </b-col>
            </b-row>              

            <b-card no-body>
            <b-tabs card v-model="tabIndex">
                <b-tab title="AP Payment" active>
                <b-table
                    class="mb-0"
                    ref="tblApPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="apPayment.items"
                    :fields="apPayment.fields"
                    :current-page="apPayment.page"
                    :per-page="apPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaibayar)="data">
                        {{data.item.nilaibayar|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeap)="data">
                        {{data.item.kurskeap|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editApPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delApPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2 mr-3">
                            <b-col class="pr-4" cols="6">
                                <b-form-group label-cols=3 label-for="apInvoice" label="AP Invoice">
                                    <b-input-group >
                                        <b-form-input readonly v-model="apPayment.obj.invoice" @keyup.13.native="lkuApShow=true" :state="!$v.apPayment.obj.apinvkey.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="lkuApShow=true" id="apInvoice">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group  label-cols=3  label="Supplier/Vendor" >
                                    <b-form-input v-model="apPayment.obj.vendorinfo"  readonly></b-form-input>
                                </b-form-group>
                                <b-form-group  label-cols=3  label="Description" >
                                    <b-form-input v-model="apPayment.obj.uraian" disabled></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols=3  label="AP Outstanding" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number class="form-control text-right" separator="," v-model="apPayment.obj.outstand" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                    <b-input-group >
                                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span></b-input-group-prepend>
                                        <my-number class="form-control text-right" separator="," v-model="apPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                        <b-form-input v-model="apPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3  label="Payment in Original AP" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="apPayment.obj.nilaibayar" @change="calcNilaibankAP" :precision="2" :state="!$v.apPayment.obj.nilaibayar.$error" ></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="apPayment.obj.nilaibank" @change="calcKurskeAp" :precision="2" :state="!$v.apPayment.obj.nilaibank.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Exchange Rate Cash/Bank to AP" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text pl-2 pr-2" >{{model.matauang}} to {{apPayment.obj.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number class="form-control text-right" separator="," v-model="apPayment.obj.kurskeap" @change="calcNilaibankAP" :precision="6" :state="!$v.apPayment.obj.nilaibank.$error"></my-number>
                                    </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="apPayment.obj.cashflow" :state="!$v.apPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('apPayment')"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCashflow('apPayment')" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveApPayment()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addApPayment" :disabled="!(model.kodebank)">Add AP Payment</b-button>                          
                    <div class="ml-2">
                        Showing
                        {{(apPayment.page - 1) * apPayment.limit + 1}}
                        to
                        {{apPayment.page * apPayment.limit}}
                        of
                        {{apPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="apPayment.total"
                        :per-page="apPayment.limit"
                        v-model="apPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Cash Advance">
                <b-table
                    class="mb-0"
                    ref="tblAdvPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="advPayment.items"
                    :fields="advPayment.fields"
                    :current-page="advPayment.page"
                    :per-page="advPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursKeAdv)="data">
                        {{data.item.kursKeAdv|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editAdvPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delAdvPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="caNumber" label="Cash Advance No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="advPayment.obj.nomor" @keyup.13.native="lkuAdvShow=true" :state="!$v.advPayment.obj.advanKey.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuAdvShow=true" id="caNumber">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="advPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="advPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Request Amount" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="advPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="advPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="advPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number v-model="advPayment.obj.nilaiByr"  :state="!$v.advPayment.obj.nilaiByr.$error" @change="updateAdvpaym"  :disabled="(advPayment.obj.nonPJ==1)" class="form-control text-right" separator="," :precision="2" ></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="advPayment.obj.nilaiBank"  :precision="2" :state="!$v.advPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2" >{{model.matauang}} to {{advPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," :precision="6" v-model="advPayment.obj.kursKeAdv" :state="!$v.advPayment.obj.kursKeAdv.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="advPayKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="advPayment.obj.cashflow" :state="!$v.advPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('advPayment')" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="showLkuCashflow('advPayment')" id="advPayKodecash">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveAdvPayment()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addAdvPayment" :disabled="!(model.kodebank)">Add Advance Payment</b-button>                          
                    <div class="ml-2">
                        Showing
                        {{(advPayment.page - 1) * advPayment.limit + 1}}
                        to
                        {{advPayment.page * advPayment.limit}}
                        of
                        {{advPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="advPayment.total"
                        :per-page="advPayment.limit"
                        v-model="advPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>

                </b-tab>
                <b-tab title="Adv.Settle (Excess Expenses)">
                <b-table
                    class="mb-0"
                    ref="tblAdvSetPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="advSetPayment.items"
                    :fields="advSetPayment.fields"
                    :current-page="advSetPayment.page"
                    :per-page="advSetPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursBankKeAdv)="data">
                        {{data.item.kursBankKeAdv|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editAdvSetPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delAdvSetPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="advSetNumber" label="Advance Settlement No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="advSetPayment.obj.nomor" @keyup.13.native="lkuAdvSetShow=true" :state="!$v.advSetPayment.obj.advSttlKey.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuAdvSetShow=true" id="advSetNumber">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="advSetPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="advSetPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Exceeds Expense" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="advSetPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="advSetPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="advSetPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="advSetPayment.obj.nilaiByr" :precision="2" :state="!$v.advSetPayment.obj.nilaiByr.$error" @change="updateAdvSetpaym"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="advSetPayment.obj.nilaiBank" :precision="2" :state="!$v.advSetPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{advSetPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," :precision="6" v-model="advSetPayment.obj.kursBankKeAdv" :state="!$v.advSetPayment.obj.kursBankKeAdv.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="advSetKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="advSetPayment.obj.cashflow" :state="!$v.advSetPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('advSetPayment')" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="showLkuCashflow('advSetPayment')" id="advSetKodecash">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveAdvSetPayment()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addAdvSetPayment" :disabled="!(model.kodebank)">Add Advance Settlement Payment</b-button>                          
                    <div class="ml-2">
                        Showing
                        {{(advSetPayment.page - 1) * advSetPayment.limit + 1}}
                        to
                        {{advSetPayment.page * advSetPayment.limit}}
                        of
                        {{advSetPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="advSetPayment.total"
                        :per-page="advSetPayment.limit"
                        v-model="advSetPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Expense Reimbursment">
                <b-table
                    class="mb-0"
                    ref="tblExpPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="expPayment.items"
                    :fields="expPayment.fields"
                    :current-page="expPayment.page"
                    :per-page="expPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursKeExp)="data">
                        {{data.item.kursKeExp|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editExpPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delExpPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="expNumber" label="Expense Reimbursment No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="expPayment.obj.nomor" @keyup.13.native="lkuExpShow=true" :state="!$v.expPayment.obj.expenKey.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuExpShow=true" id="expNumber">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="expPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="expPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Expense" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="expPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="expPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="expPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="expPayment.obj.nilaiByr" :precision="2" :state="!$v.expPayment.obj.nilaiByr.$error" @change="updateExppaym"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="expPayment.obj.nilaiBank" :precision="2" :state="!$v.expPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{expPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," :precision="6" v-model="expPayment.obj.kursKeExp" :state="!$v.expPayment.obj.kursKeExp.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="expKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="expPayment.obj.cashflow" :state="!$v.expPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('expPayment')" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="showLkuCashflow('expPayment')" id="expKodecash">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveExpPayment()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addExpPayment" :disabled="!(model.kodebank)">Add Expense Reimbursment Payment</b-button>                          
                    <div class="ml-2">
                        Showing
                        {{(expPayment.page - 1) * expPayment.limit + 1}}
                        to
                        {{expPayment.page * expPayment.limit}}
                        of
                        {{expPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="expPayment.total"
                        :per-page="expPayment.limit"
                        v-model="expPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Transfer Account">
                <b-table
                    class="mb-0"
                    ref="tblTranPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="tranPayment.items"
                    :fields="tranPayment.fields"
                    :current-page="tranPayment.page"
                    :per-page="tranPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(valas_in)="data">
                        {{data.item.valas_in|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeap)="data">
                        {{data.item.kurskeap|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editTranPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delTranPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2 mr-3">
                            <b-col class="pr-4" cols="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Transfer to Bank Acc.</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="tranPayment.obj.namabank" @keyup.13.native="lkuBanktujuanShow=true" :state="!$v.tranPayment.obj.kodebank2.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuBanktujuanShow=true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>

                                <b-input-group >
                                    <b-input-group-prepend><label>Bank Account No.</label></b-input-group-prepend>
                                    <b-form-input disabled v-model="tranPayment.obj.nomorrek"></b-form-input>
                                    <b-input-group-append>
                                        <span class="input-group-text" style="width:70px;">{{tranPayment.obj.matauang2}}</span>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Amount in Destination Acc.</label></b-input-group-prepend>
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{tranPayment.obj.matauang2}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="tranPayment.obj.valas_in" :precision="2" :state="!$v.tranPayment.obj.valas_in.$error" ></my-number>
                                </b-input-group>
                            </b-col>
                            <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="tranPayment.obj.nilaibank" :precision="2" :state="!$v.tranPayment.obj.nilaibank.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Exchange Rate to Destination" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{tranPayment.obj.matauang2}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," :precision="6" v-model="tranPayment.obj.kurstrx" :state="!$v.tranPayment.obj.kurstrx.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="tranPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('tranPayment')"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCashflow('tranPayment')" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveTranPayment()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addTranPayment" :disabled="!(model.kodebank)">Add Transfer Account</b-button>                          
                    <div class="ml-2">
                        Showing
                        {{(tranPayment.page - 1) * tranPayment.limit + 1}}
                        to
                        {{tranPayment.page * tranPayment.limit}}
                        of
                        {{tranPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="tranPayment.total"
                        :per-page="tranPayment.limit"
                        v-model="tranPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Other">
                <b-table
                    class="mb-0"
                    ref="tblOthPayment"
                    outlined
                    striped hover small
                    :items="othPayment.items"
                    :fields="othPayment.fields"
                    :current-page="othPayment.page"
                    :per-page="othPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(umasuk)="data">
                        {{data.item.umasuk|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOthPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delOthPayment(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="glAccount" label="GL Account No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.othPayment.obj.kodeacc.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuCoaShow=true" id="glAccount">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="othPayment.obj.uraian" :state="!$v.othPayment.obj.uraian.$error"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" separator="," v-model="othPayment.obj.umasuk" :minus="true" :precision="2" :state="!$v.othPayment.obj.umasuk.$error"></my-number>
                                    <b-input-group-append><span class="pt-2 ml-1" > DB &nbsp; ( <i class="fa fa-minus-square"></i> CR)</span></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label-for="othPayKodecash" label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.cashflow" :state="!$v.othPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('othPayment')" ></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCashflow('othPayment')" id="othPayKodecash">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                        </b-col>
                        <b-col class="pr-4" cols="6">
                            <v-dim :model="othPayment.obj" :key="updateDimDtl"></v-dim>
                            
                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveOthPayment()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addOthPayment" :disabled="!(model.tanggal)">Add Other Payment</b-button>       
                        <div class="ml-2 mt-1" >
                          Showing {{(othPayment.page - 1) * othPayment.limit + 1}}
                          to <span v-if="((othPayment.page * othPayment.limit)>othPayment.total)">{{othPayment.total}}</span> <span v-else>{{othPayment.page * othPayment.limit}}</span>
                          of {{othPayment.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="othPayment.limit"  style="width:60px;">
                            <option>5</option>                            
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                          </select>
                        </div>
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="othPayment.total"
                        :per-page="othPayment.limit"
                        v-model="othPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
            </b-tabs>
            </b-card>    
            <b-row>
                <b-col cols="4">
                    <b-form-group  label-cols=3  label="Total Detail Payment" >
                        <b-input-group >
                            <b-input-group-prepend>
                            <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="totalDtlPaym" :precision="2" disabled></my-number>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="8">
                    <!-- <div class="text-right">
                        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                    </div> -->
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                            <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>

                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuApShow" size="xl" :hide-footer="true" title="List of AP Outstanding" :centered="true" :lazy="true">
            <lku-ap @click="onSelectLkuAp" :formdata="lkuApData"></lku-ap>
        </b-modal>        
        <b-modal v-model="lkuAdvShow" size="xl" :hide-footer="true" title="List of Cash Advance Outstanding" :centered="true" :lazy="true">
            <lku-adv @click="onSelectLkuAdv"></lku-adv>
        </b-modal>        
        <b-modal v-model="lkuAdvSetShow" size="xl" :hide-footer="true" title="List of Cash Advance Settlement Outstanding Exceeds Expense" :centered="true" :lazy="true">
            <lku-advset @click="onSelectLkuAdvSet"></lku-advset>
        </b-modal>        
        <b-modal v-model="lkuExpShow" size="xl" :hide-footer="true" title="List of Expense Reimbursment Outstanding" :centered="true" :lazy="true">
            <lku-exp @click="onSelectLkuExp" :formdata="lkuExpData"></lku-exp>
        </b-modal>        
        <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true" :lazy="true">
            <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="OUT"></lku-cashflow>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="bankOnly" :key="bankOnly" aktif="1" :formdata="lkuBankaccountData"></lku-bankaccount>
        </b-modal>        
        <b-modal v-model="lkuBanktujuanShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-destaccount @click="onSelectLkuBanktujuan"  ></lku-destaccount>
        </b-modal>     
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>

<style lang="scss">
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 150px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuAp from "../lookup/lkuApLazzy";
import lkuAdv from "../lookup/lkuAdv.1";
import lkuAdvset from "../lookup/lkuAdvset_cr.1";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import lkuDestaccount from "../lookup/lkuBankaccountAll";
import lkuExp from "../lookup/lkuExpLazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import tranbank from "../../apis/rop";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim, lkuAp, lkuAdv, lkuAdvset,lkuBankaccount,lkuDestaccount,lkuExp,lkuCashflow,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            kodebank: { required },
            uraian: { required },
            tanggal: { required },
            jenis: { required },
            matauang: { required },
            terimadari: { required },
            valas_out: { required, minValue:minValue(0.01) },
            kurstrx: { required, minValue:minValue(0.00000001) }
        },
    apPayment: {
        obj: {
            apinvkey: { required },
            kodecash: { required },
            nilaibayar: { required, minValue:minValue(0.01) },
            nilaibank: { required, minValue: minValue(0.01) },
            kurskeap: { required, minValue:minValue(0.001) }
        }
    },
    advPayment: {
        obj :{
            advanKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursKeAdv: { required, minValue:minValue(0.0000001) }
        }
    },
    advSetPayment: {
        obj :{
            advSttlKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursBankKeAdv: { required, minValue:minValue(0.0000001) }
        }
    },
    expPayment: {
        obj :{
            expenKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursKeExp: { required, minValue:minValue(0.0000001) }
        }
    },
    tranPayment: {
        obj :{
            kodebank2: { required },
            matauang2: { required },
            // kodecash: { required },
            nilaibank: { required, minValue:minValue(0.01) },
            valas_in: { required, minValue:minValue(0.01) },
            kurstrx: { required, minValue:minValue(0.0000001) }
        }
    },
    othPayment: {
        obj :{
            kodeacc: { required },
            uraian: { required },
            kodecash: { required },
            umasuk: { required },
        }
    },

  }, 
  data() {
    return {
        currency:[{value:'IDR',text:'IDR'}],
        isLoading: false,
        showReport:false,
        reportUrl: null,
        saveEnabled:true,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Debet R/K', 'Kredit R/K', 'Tunai'],
        model: {jenis:'Giro',kodecash:'-',
            kodebank: '',
            uraian: '',
            tanggal: '',
            jenis: 'Giro',
            matauang: this.$store.state.user.matauang,
            terimadari: '',
            valas_out: 0,
            kurstrx: 1
        },

        lblExchRate:"Exch. Rate to ",
        bankOnly:1,
        lkuBankaccountData:{},
        lkuBankaccountShow:false,
        lkuBanktujuanShow:false,
        lkuCashflowData:{},
        lkuCashflowShow: false,
        lkuCashflowCaller:'apPayment',        
        tabIndex:0,
        tahun:new Date().getFullYear(),
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        apPayment: {
            items: [],
            selected:{},
            obj:{apinvkey:'', kodecash:'',vendor:'', vendorinfo:'',nilaibayar: 0, nilaibank: 0, kurskeap: 1, kurspost:1, selisihkurs:0, byr_semu:0},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "AP Number"
                },
                {
                    key: "invoice",
                    label: "Invoice Number",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibayar",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeap",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuApShow: false,
        lkuApData:{},
        advPayment: {
            items: [],
            selected:{},
            obj :{
                advanKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursKeAdv: 1, byr_semu:0, nonPJ:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "Request Number"
                },
                {
                    key: "keterangan",
                    label: "Cash Advance Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursKeAdv",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuAdvShow: false,
        expPayment: {
            items: [],
            selected:{},
            obj :{
                expenKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursKeExp: 1, byr_semu:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "Reimbursment Number"
                },
                {
                    key: "keterangan",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursKeExp",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuExpShow: false,
        lkuExpData:{},        
        advSetPayment: {
            items: [],
            selected:{},
            obj :{
                advSttlKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursBankKeAdv: 1, byr_semu:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "AP Number"
                },
                {
                    key: "keterangan",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursBankKeAdv",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuAdvSetShow: false,
        othPayment: {
            items: [],
            selected:{},
            obj :{
                kodeacc: '',glAccount:'',
                uraian: '',
                kodecash: '',
                umasuk: 0,  DimDtl:{}
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "umasuk",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuCoaShow:false,
        tranPayment: {
            items: [],
            selected:{},
            obj :{
                kodebank2: '',
                matauang2: '',
                kodecash: '',
                nilaibank: 0,
                valas_in: 0,
                kurstrx: 1
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "namabank",
                    thStyle: "width:150px",
                    label: "Trasfer To Bank/Cash"
                },
                {
                    key: "nomorrek",
                    label: "Account Number",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "matauang2",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "valas_in",
                    label: "Amount in Destination Acc.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurstrx",
                    label: "Exch.Rate to Destination",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidApPayment() {
      this.$v.apPayment.obj.$touch();
      return this.$v.apPayment.obj.$invalid;
    },
    invalidAdvPayment() {
      this.$v.advPayment.obj.$touch();
      return this.$v.advPayment.obj.$invalid;
    },
    invalidExpPayment() {
      this.$v.expPayment.obj.$touch();
      return this.$v.expPayment.obj.$invalid;
    },
    invalidAdvSetPayment() {
      this.$v.advSetPayment.obj.$touch();
      return this.$v.advSetPayment.obj.$invalid;
    },
    invalidTranPayment() {
      this.$v.tranPayment.obj.$touch();
      return this.$v.tranPayment.obj.$invalid;
    },
    invalidOthPayment() {
      this.$v.othPayment.obj.$touch();
      return this.$v.othPayment.obj.$invalid;
    },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
    bankkas2(){
        return this.tranPayment.obj.kodebank2;
    },
  },
  watch: {
      
    caraBayar: function(jenis) {
        if (jenis==='Tunai') {
            this.bankOnly='0';
        } else {
            this.bankOnly='1';
        }
        if (this.model.isbank!=this.bankOnly) {
            this.model.kodebank='';
            this.model.namabank='';
        }
    },    
    bankkas: function(kode) {
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
    },    
    bankkas2: function(kode) {
        // let acc = this.bankCashAcc.find(r => r.kode===kode);
        // if (acc){
        //     this.tranPayment.obj.namabank=acc.namabank || acc.namabank2;
        //     this.tranPayment.obj.nomorrek=acc.nomorrek;
        //     this.tranPayment.obj.matauang2=acc.matauang;
            if (this.tranPayment.obj.matauang2.trim() == this.model.matauang.trim()) {
                this.tranPayment.obj.kurstrx = 1;
                let sisa=(this.model.valas_out || 0) - this.totalDtlPaym - (this.model.bcharge||0);
                this.tranPayment.obj.valas_in = sisa;
                this.tranPayment.obj.nilaibank= sisa;
            }
        // }
    }, 
  },
  created: async function(){
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;

      if (this.$route.params.id) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            // this.inputBerlanjut=0;
            const [a,data] = await Promise.all([tranbank.currency(),await tranbank.paymentdetail(this.$route.params)]) ;
            this.currency = a;

            // const data = await tranbank.paymentdetail(this.$route.params);  
            const row = data[0][0];
            this.saveEnabled=(row.poststatus === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }

            this.apPayment.items = data[1];
            this.apPayment.total=this.apPayment.items.length;
            this.advPayment.items = data[2];
            this.advPayment.total=this.advPayment.items.length;
            this.advSetPayment.items = data[3];
            this.advSetPayment.total=this.advSetPayment.items.length;
            this.expPayment.items = data[4];
            this.expPayment.total=this.expPayment.items.length;
            this.othPayment.items = data[5];
            this.othPayment.total=this.othPayment.items.length;
            this.tranPayment.items = data[6];
            this.tranPayment.total=this.tranPayment.items.length;
            if (this.apPayment.items.length>0) {this.tabIndex=0;
            } else if (this.advPayment.items.length>0) {this.tabIndex=1;
            } else if (this.advSetPayment.items.length>0) {this.tabIndex=2;
            } else if (this.expPayment.items.length>0) {this.tabIndex=3;
            } else if (this.tranPayment.items.length>0) {this.tabIndex=4;
            } else if (this.othPayment.items.length>0) {this.tabIndex=5;}
            this.calcTotalDtlPaym();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            // if (this.model.jenis==='Tunai'){
            //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            // } 
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        this.currency = await tranbank.currency();
         this.model.tanggal = moment().format('YYYY-MM-DD');
      }
  },
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.nomorrek=lkuData.selected.nomorrek;
        this.model.isbank=lkuData.selected.isbank;
        this.lkuBankaccountShow=false;
    },
    onSelectLkuBanktujuan(_selected) {
        this.lkuBanktujuanShow=false;
        this.tranPayment.obj.kodebank2=_selected.kode;
        this.tranPayment.obj.matauang2=_selected.matauang;
        this.tranPayment.obj.namabank=_selected.namabank || _selected.namabank2;;
        this.tranPayment.obj.nomorrek=_selected.nomorrek;
        // this.tranPayment.obj.isbank=_selected.isbank;
        this.lkuBanktujuanShow=false;
    },
    showLkuCashflow(callerObj) {
        this.lkuCashflowShow=true;
        this.lkuCashflowCaller=callerObj;
    },
    onSelectLkuCashflow(lkuData) {
        this.lkuCashflowData=lkuData;
        this.lkuCashflowShow=false;
        this[this.lkuCashflowCaller].obj.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].obj.kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].obj.namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = lkuData.selected.kodecash.trim() + ' | ' + lkuData.selected.namacash.trim();
            this.model.kodecash = lkuData.selected.kodecash;
            this.model.namacash = lkuData.selected.namacash;
        }
        this.lkuCashflowShow=false;
    },
    save: async function () {
            if (!this.saveEnabled) {
                toastr.error('View mode cannot be Saved');
                return;
            }
            this.isLoading=true;
            if (this.invalidModel) {
                console.log('validation model : ', this.$v.model);
                console.log('model obj : ',this.model);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.isLoading=false;   
                return;
            } else if ((this.uanguser.trim() !== this.model.matauang.trim()) && (this.model.kurstrx==1)) {
                toastr.error(`Please fill the Exchange Rate of ${this.model.matauang}`, "ERROR MESSAGE",10000);
                this.isLoading=false;          
                return;
            } else if (Math.abs(this.totalDtlPaym - parseFloat(this.model.valas_out))>0.01) {
                toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
                this.isLoading=false;      
                return;
            } else {
                this.model.TableName = 'tranbank';
                try {
                    const dimValResult = await dimension.validate(this.model);
                    if (dimValResult.success) {
                        this.model.nomor = this.model.nomor || '';
                        this.model.isvoid = this.model.isvoid || 0;
                        this.model.poststatus = this.model.poststatus || 0;
                        this.model.valas_in = this.model.valas_in || 0;
                        this.model.valas_out = this.model.valas_out || 0;
                        this.model.bcharge = this.model.bcharge || 0;

                        const row = {};
                        for (var key in this.model) {
                            row[key] = this.model[key];
                        }
                        row.mode='payment';
                        row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                        row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                        row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tanggal).format('YYYY-MM-DD');

                        const kurspost=this.model.kurstrx;

                        let newApPayments = this.apPayment.items.reduce((newArr, item) => {
                            if ((item.apinvkey || '') != '') {
                                item.kurspost = item.kurskeap*this.model.kurstrx;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        let newAdvPayments = this.advPayment.items.reduce((newArr, item) => {
                            if ((item.advanKey || '') != '') {
                                // item.kurspost = kurspost;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        let newAdvSetPayments = this.advSetPayment.items.reduce((newArr, item) => {
                            if ((item.advSttlKey || '') != '') {
                                item.kursBank = kurspost;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        let newExpPayments = this.expPayment.items.reduce((newArr, item) => {
                            if ((item.expenKey || '') != '') {
                                // item.kurspost = kurspost;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        let newOthPayments = this.othPayment.items.reduce((newArr, item) => {
                            if ((item.kodeacc || '') != '') {
                                // item.kurspost = kurspost;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);
                        let newTranPayments = this.tranPayment.items.reduce((newArr, item) => {
                            if ((item.kodebank2 || '') != '') {
                                // item.kurspost = kurspost;
                                item.kurspost = item.bank_in/item.valas_in;
                                newArr.push(item);
                            }
                            return newArr;
                        }, []);

                        row.apPayment=newApPayments;
                        row.advPayment = newAdvPayments;
                        row.advSetPayment = newAdvSetPayments;
                        row.expPayment = newExpPayments;
                        row.othPayment = newOthPayments;
                        row.tranPayment = newTranPayments;
                        // await tranbank.insert(row);
                        // toastr.success("Complete successfully", "Save Payment");
                        const hasil= await tranbank.insert(row);
                        toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Payment",10000);
                            this.isLoading=false;
                        if (this.inputBerlanjut==0){
                            this.close();
                        } else {
                            this.$bvModal.msgBoxConfirm('Do You want to Print Form/Voucher ?', {
                            title: 'Please Confirm',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            okTitle: 'YES',
                            cancelTitle: 'NO',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                            })
                            .then(async(value) => {
                                if (value==true){
                                    try {
                                        this.showReport=true;
                                        this.reportUrl= await tranbank.print(hasil);
                                    } catch (error) {
                                        if (error.message) {
                                            toastr.error(error.message);
                                        } else {
                                            toastr.error(JSON.stringify(error));
                                        }
                                    }
                                }
                                    // this.close();
                            })
                            .catch(err => {
                            // An error occurred
                            })                

                            this.saveEnabled=true;            
                            const _selected= {
                                kode: this.model.kodebank,
                                matauang: this.model.matauang,
                                namabank: this.model.namabank,
                                nomorrek: this.model.nomorrek,
                                isbank:this.model.isbank,
                                jenis: this.model.jenis
                            }
                            for (var key in this.model) {
                                this.model[key] = '';
                            }
                            this.model.kurstrx=1;
                            this.model.valas_out= 0;
                            this.model.tanggal = moment().format('YYYY-MM-DD');
                            this.model.tgl_terima = moment().format('YYYY-MM-DD');
                            this.model.kodebank=_selected.kode;
                            this.model.matauang=_selected.matauang;
                            this.model.namabank=_selected.namabank;
                            this.model.nomorrek=_selected.nomorrek;
                            this.model.isbank=_selected.isbank;
                            this.model.jenis=_selected.jenis;
                            
                            this.bankOnly=1;
                            this.tabIndex=0;
                            this.tahun=new Date().getFullYear();
                            this.totalDtlPaym=0;

                            this.apPayment.items=[];
                            this.advPayment.items=[];
                            this.expPayment.items=[];
                            this.tranPayment.items=[];

                            this.advSetPayment.items= [];
                            this.advSetPayment.selected= {};
                
                            this.othPayment.items= [];
                            this.othPayment.selected= {};
                            this.$v.model.$reset();                        
                    }

                    } else {
                        console.log('dimValResult : ', dimValResult);
                        var msg = dimValResult.message || 'Dimension validation error';
                        toastr.error(msg, "ERROR MESSAGE");
                        this.isLoading=false;     
                    }
                } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                    this.isLoading=false;     
                }

            }
    },

    closeApPayment: function(){
        const opened= this.apPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addApPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true};
        this.apPayment.selected = obj;
        // for (var key in this.apPayment.obj) {
        //     this.apPayment.obj[key] = '';
        // }
        this.apPayment.obj.appaymkey='';
        this.apPayment.obj.nilaibayar=0;
        this.apPayment.obj.nilaibank=0;
        this.apPayment.obj.kurskeap=1;
        this.apPayment.obj.kurspost=1;
        this.apPayment.obj.selisihkurs=0;

        this.apPayment.items.push(obj);
        this.apPayment.total=this.apPayment.items.length;
        setTimeout(() => {
            const bfore = this.apPayment.page;
            const after =Math.ceil((this.apPayment.total)/this.apPayment.limit);
            if (bfore != after){
                this.apPayment.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.apPayment.total} items`,'Detail AP PAYMENT',10000);
            }

        }, 100);       
        this.inputLineBerlanjut=1;
    },
    editApPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.apPayment.selected = obj;
        // for (var key in this.apPayment.obj) {
        //     this.apPayment.obj[key] = '';
        // }
        this.apPayment.obj.appaymkey='';
        this.apPayment.obj.nilaibayar=0;
        this.apPayment.obj.nilaibank=0;
        this.apPayment.obj.kurskeap=1;
        this.apPayment.obj.kurspost=1;
        this.apPayment.obj.selisihkurs=0;
        for (var key in obj) {
            this.apPayment.obj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delApPayment: function (index) {
        if (!this.saveEnabled) return;
        if (index > -1) {
            // this.apPayment.items.splice(index, 1);
            const posisi = (this.apPayment.page-1)*this.apPayment.limit;
            this.apPayment.items.splice(posisi+index, 1);
        }
        this.apPayment.total=this.apPayment.items.length;
        this.calcTotalDtlPaym();
    },
    onSelectLkuAp(invLookup) {
        this.lkuApShow=false;
        this.lkuApData=invLookup;
        const ada = this.apPayment.items.find(ap => ap.apinvkey == invLookup.selected.apinvkey);
        if (ada) {
            // if (ada.appaymkey!== this.apPayment.selected.appaymkey) {
                toastr.error(`AP Number ${invLookup.selected.nomor} already on paid list`,'ERROR MESSAGE',10000);
                return;
            // }
        }        
        this.apPayment.obj.apinvkey=invLookup.selected.apinvkey;
        this.apPayment.obj.nomor=invLookup.selected.nomor;
        this.apPayment.obj.invoice=invLookup.selected.invoice;
        this.apPayment.obj.uraian=invLookup.selected.uraian;
        this.apPayment.obj.vendor=invLookup.selected.vendor;
        this.apPayment.obj.vendorinfo=invLookup.selected.vendorinfo;
        this.model.terimadari=invLookup.selected.vendorinfo;
        this.apPayment.obj.matauang=invLookup.selected.matauang;
        this.apPayment.obj.totalinv=invLookup.selected.totalinv;
        this.apPayment.obj.outstand=invLookup.selected.outstand;
        this.apPayment.obj.nilaibayar=invLookup.selected.outstand;
        this.apPayment.obj.cashflow=invLookup.selected.cashflow;
        this.apPayment.obj.kodecash=(invLookup.selected.kodecash||'').trim();
        this.updateDimDtl2Hdr(invLookup.selected);
        if ((this.model.uraian || '') == '') {
            this.model.uraian=invLookup.selected.uraian;
        }

        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = this.apPayment.obj.cashflow;
            this.model.kodecash = this.apPayment.obj.kodecash;
            // this.model.namacash = this.apPayment.obj.namacash;
        }
        if (this.apPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.apPayment.obj.nilaibank=invLookup.selected.outstand;
            this.apPayment.obj.kurskeap = 1;
            this.apPayment.obj.selisihkurs = 0;
        }

        tranbank.byrsemu(invLookup.selected).then(result => {
                this.apPayment.obj.byr_semu= result.byr_semu;
                this.apPayment.obj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu -> ', err);
            });

    },
    calcKurskeAp: function(){
        setTimeout(() => {
                if (this.apPayment.obj.matauang.trim() == this.model.matauang.trim()) {
                    this.apPayment.obj.nilaibank=this.apPayment.obj.nilaibayar;
                    this.apPayment.obj.kurskeap = 1;
                } else {
                    this.apPayment.obj.kurskeap=this.apPayment.obj.nilaibank/this.apPayment.obj.nilaibayar;
                }            
        }, 500);
    },
    calcNilaibankAP: function(){
        setTimeout(() => {
                if (this.apPayment.obj.matauang.trim() == this.model.matauang.trim()) {
                    this.apPayment.obj.nilaibank=this.apPayment.obj.nilaibayar;
                    this.apPayment.obj.kurskeap = 1;
                } else {
                    if ((this.apPayment.obj.kurskeap) && (this.apPayment.obj.nilaibayar)) {
                        this.apPayment.obj.nilaibank=this.apPayment.obj.nilaibayar*this.apPayment.obj.kurskeap;
                    }
                }            
        }, 500);
    },
    saveApPayment: function (callback) {
        this.apPayment.obj.nilaibank = this.apPayment.obj.nilaibank || 0;
        this.apPayment.obj.nilaibayar = this.apPayment.obj.nilaibayar || 0;
        if (this.invalidApPayment) {
            console.log('validation apPayment : ', this.$v.apPayment.obj);
            console.log('selected Ap : ',this.apPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        // } else if (this.apPayment.obj.nilaibayar>this.apPayment.obj.outstand){
        } else if ((!(this.apPayment.obj.appaymkey)) && ((this.apPayment.obj.nilaibayar+(this.apPayment.obj.byr_semu||0)-this.apPayment.obj.outstand) > 0.01)){
            toastr.error('Payment Amount exceeds Outstanding Amount', "ERROR MESSAGE");
        } else {
            this.apPayment.obj.selisihkurs = this.apPayment.obj.nilaibank - (this.apPayment.obj.nilaibayar * this.apPayment.obj.kurskeap);
            for (var key in this.apPayment.obj) {
                this.apPayment.selected[key] = this.apPayment.obj[key];
            }
            this.apPayment.selected._showDetails=false;
            this.calcTotalDtlPaym();
            this.updateDimDtl2Hdr(this.apPayment.obj);

            if (callback) callback();
        }
    },

    closeAdvPayment: function(){
        const opened= this.advPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAdvPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true};
        this.advPayment.selected = obj;
        for (var key in this.advPayment.obj) {
            this.advPayment.obj[key] = '';
        }
        this.advPayment.items.push(obj);
        this.advPayment.total=this.advPayment.items.length;
        setTimeout(() => {
            const bfore = this.advPayment.page;
            const after =Math.ceil((this.advPayment.total)/this.advPayment.limit);
            if (bfore != after){
                this.advPayment.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.advPayment.total} items`,'Detail ADV PAYMENT',10000);
            }
        }, 100);       
        this.inputLineBerlanjut=1;
    },
    editAdvPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.advPayment.selected = obj;
        for (var key in this.advPayment.obj) {
            this.advPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.advPayment.obj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delAdvPayment: function (index) {
        if (!this.saveEnabled) return;
        if (index > -1) {
            // this.advPayment.items.splice(index, 1);
            const posisi = (this.advPayment.page-1)*this.advPayment.limit;
            this.advPayment.items.splice(posisi+index, 1);
        }
        this.advPayment.total=this.advPayment.items.length;
        this.calcTotalDtlPaym();
    },
    saveAdvPayment: function (callback) {
        // this.updateAdvpaym();
        this.advPayment.obj.nilaiBank = this.advPayment.obj.nilaiBank || 0;
        this.advPayment.obj.nilaiByr = this.advPayment.obj.nilaiByr || 0;
        if (this.invalidAdvPayment) {
            console.log('validation advPayment : ', this.$v.advPayment.obj);
            console.log('selected Adv : ',this.advPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
    //    } else if (this.advPayment.obj.nilaiByr>this.advPayment.obj.outstand){
       } else if ((this.advPayment.obj.nilaiByr+(this.advPayment.obj.byr_semu||0)-this.advPayment.obj.outstand) > 0.01) {
            toastr.error('Payment Amount exceeds Outstanding Amount', "ERROR MESSAGE");
       } else {
            this.advPayment.obj.selisihKurs = this.advPayment.obj.nilaiBank - (this.advPayment.obj.nilaiByr * this.advPayment.obj.kursKeAdv);
            for (var key in this.advPayment.obj) {
                this.advPayment.selected[key] = this.advPayment.obj[key];
            }
            this.calcTotalDtlPaym();
            this.advPayment.selected._showDetails=false;
            if (callback) callback();
            if (this.inputLineBerlanjut==1) {
                this.addAdvPayment();
                this.$v.advPayment.obj.$reset();                        
            }                    

        }
    },
    onSelectLkuAdv(_selected) {
        this.lkuAdvShow=false;
        const ada = this.advPayment.items.find(ap => ap.advanKey == _selected.advanKey);
        if (ada) {
            // if (ada.advPayKey!== this.advPayment.selected.advPayKey) {
                toastr.error(`ADV Number ${_selected.nomor} already on paid list`,'ERROR MESSAGE',10000);
                return;
            // }
        }        
        this.advPayment.obj.advanKey=_selected.advanKey;
        this.advPayment.obj.nomor=_selected.nomor;
        this.advPayment.obj.dibayarke=_selected.dibayarke;
        this.advPayment.obj.keterangan=_selected.keterangan;
        this.advPayment.obj.crewkey=_selected.crewkey;
        this.advPayment.obj.nik=_selected.crewnik;
        this.advPayment.obj.crewinfo=_selected.crewinfo;
        this.advPayment.obj.matauang=_selected.matauang;
        this.advPayment.obj.jumlah=_selected.jumlah;
        this.advPayment.obj.outstand=_selected.outstand;
        this.advPayment.obj.nilaiByr=_selected.outstand;
        this.advPayment.obj.nonPJ=_selected.nonPJ;
        this.advPayment.obj.cashflow=_selected.cashflow;
        this.advPayment.obj.kodecash=_selected.kodecash;
        this.updateDimDtl2Hdr(_selected);
        if ((this.model.uraian || '') == '') {
            this.model.uraian=_selected.keterangan;
        }
        if ((this.model.terimadari || '') == '') {
            this.model.terimadari=_selected.crewinfo;
        }

        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = this.advPayment.obj.cashflow;
            this.model.kodecash = this.advPayment.obj.kodecash;
            // this.model.namacash = this.advPayment.obj.namacash;
        }
        if (this.advPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.advPayment.obj.nilaiBank=_selected.outstand;
            this.advPayment.obj.kursKeAdv = 1;
            this.advPayment.obj.selisihkurs = 0;
        }
        tranbank.byrsemuAdv(_selected).then(result => {
                this.advPayment.obj.byr_semu= result.byr_semu;
                this.advPayment.obj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu Adv -> ', err);
            });
    },
    updateAdvpaym: function() {
        if (this.advPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.advPayment.obj.nilaiBank=this.advPayment.obj.nilaiByr;
            this.advPayment.obj.kursKeAdv = 1;
        }
    },
    closeAdvSetPayment: function(){
        const opened= this.advSetPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAdvSetPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true, kodecash:'-'};
        this.advSetPayment.selected = obj;
        for (var key in this.advSetPayment.obj) {
            this.advSetPayment.obj[key] = '';
        }
        this.advSetPayment.items.push(obj);
        this.advSetPayment.total=this.advSetPayment.items.length;
        setTimeout(() => {
            const bfore = this.advSetPayment.page;
            const after =Math.ceil((this.advSetPayment.total)/this.advSetPayment.limit);
            if (bfore != after){
                this.advSetPayment.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.advSetPayment.total} items`,'Detail ADV STTL. PAYMENT',10000);
            }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editAdvSetPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.advSetPayment.selected = obj;
        for (var key in this.advSetPayment.obj) {
            this.advSetPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.advSetPayment.obj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delAdvSetPayment: function (index) {
        if (!this.saveEnabled) return;
        if (index > -1) {
            // this.advSetPayment.items.splice(index, 1);
            const posisi = (this.advSetPayment.page-1)*this.advSetPayment.limit;
            this.advSetPayment.items.splice(posisi+index, 1);
        }
        this.advSetPayment.total=this.advSetPayment.items.length;
        this.calcTotalDtlPaym();
    },
    saveAdvSetPayment: function (callback) {
        this.advSetPayment.obj.nilaiBank = this.advSetPayment.obj.nilaiBank || 0;
        this.advSetPayment.obj.nilaiByr = this.advSetPayment.obj.nilaiByr || 0;
        if (this.invalidAdvSetPayment) {
            // console.log('validation advSetPayment : ', this.$v.advSetPayment.obj);
            // console.log('selected Adv.Setlle : ',this.advSetPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
    //    } else if (this.advSetPayment.obj.nilaiByr>this.advSetPayment.obj.outstand){
       } else if ((this.advSetPayment.obj.nilaiByr+(this.advSetPayment.obj.byr_semu||0)-this.advSetPayment.obj.outstand) > 0.01) {
            toastr.error('Payment Amount exceeds Outstanding Amount', "ERROR MESSAGE");
       } else {
            this.advSetPayment.obj.selisihKurs = this.advSetPayment.obj.nilaiBank - (this.advSetPayment.obj.nilaiByr * this.advSetPayment.obj.kursBankKeAdv);
            for (var key in this.advSetPayment.obj) {
                this.advSetPayment.selected[key] = this.advSetPayment.obj[key];
            }
            this.calcTotalDtlPaym();
            this.advSetPayment.selected._showDetails=false;
            if (callback) callback();
            if (this.inputLineBerlanjut==1) {
                this.addAdvSetPayment();
                this.$v.advSetPayment.obj.$reset();                        
            }                    
        }
    },
    onSelectLkuAdvSet(_selected) {
        this.lkuAdvSetShow=false;
        const ada = this.advSetPayment.items.find(ap => ap.advSttlKey == _selected.advSttlKey);
        if (ada) {
            // if (ada.advStlDtlKey!== this.advSetPayment.selected.advStlDtlKey) {
                toastr.error(`ADV SETTLEMENT Number ${_selected.nomor} already on paid list`,'ERROR MESSAGE',10000);
                return;
            // }
        }        
        this.advSetPayment.obj.advSttlKey=_selected.advSttlKey;
        this.advSetPayment.obj.nomor=_selected.nomor;
        this.advSetPayment.obj.keterangan=_selected.keterangan;
        this.advSetPayment.obj.crewkey=_selected.crewkey;
        this.advSetPayment.obj.nik=_selected.nik;
        this.advSetPayment.obj.crewinfo=_selected.crewinfo;
        this.advSetPayment.obj.matauang=_selected.matauang;
        this.advSetPayment.obj.jumlah=_selected.jumlah;
        this.advSetPayment.obj.outstand=_selected.outstand;
        this.advSetPayment.obj.nilaiByr=_selected.outstand;
        this.advSetPayment.obj.cashflow=_selected.cashflow;
        if ((this.model.uraian || '') == '') {
            this.model.uraian=_selected.keterangan;
        }
        if ((this.model.terimadari || '') == '') {
            this.model.terimadari=_selected.crewinfo;
        }

        if (_selected.kodecash)
        {
            this.advSetPayment.obj.kodecash=_selected.kodecash;
        }
        this.updateDimDtl2Hdr(_selected);
        // this.advSetPayment.obj.namacash=_selected.namacash;
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = this.advSetPayment.obj.cashflow;
            this.model.kodecash = this.advSetPayment.obj.kodecash;
            // this.model.namacash = this.advSetPayment.obj.namacash;
        }
        if (this.advSetPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.advSetPayment.obj.nilaiBank=_selected.outstand;
            this.advSetPayment.obj.kursBankKeAdv = 1;
            this.advSetPayment.obj.selisihkurs = 0;
        }
        tranbank.byrsemuAdvSet(_selected).then(result => {
                this.advSetPayment.obj.byr_semu= result.byr_semu;
                this.advSetPayment.obj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu AdvSet-> ', err);
            });
    },
    updateAdvSetpaym: function() {
        if (this.advSetPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.advSetPayment.obj.nilaiBank=this.advSetPayment.obj.nilaiByr;
            this.advSetPayment.obj.kursBankKeAdv = 1;
        }
    },

    closeExpPayment: function(){
        const opened= this.expPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addExpPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true};
        this.expPayment.selected = obj;
        for (var key in this.expPayment.obj) {
            this.expPayment.obj[key] = '';
        }
        this.expPayment.items.push(obj);
        this.expPayment.total=this.expPayment.items.length;
        setTimeout(() => {
            const bfore = this.expPayment.page;
            const after =Math.ceil((this.expPayment.total)/this.expPayment.limit);
            if (bfore != after){
                this.expPayment.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.expPayment.total} items`,'Detail EXP.REIMBURS PAYMENT',10000);
            }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editExpPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.expPayment.selected = obj;
        for (var key in this.expPayment.obj) {
            this.expPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.expPayment.obj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delExpPayment: function (index) {
        if (index > -1) {
            // this.expPayment.items.splice(index, 1);
            const posisi = (this.expPayment.page-1)*this.expPayment.limit;
            this.expPayment.items.splice(posisi+index, 1);
        }
        this.expPayment.total=this.expPayment.items.length;
        this.calcTotalDtlPaym();
    },
    saveExpPayment: function (callback) {
        this.expPayment.obj.nilaiBank = this.expPayment.obj.nilaiBank || 0;
        this.expPayment.obj.nilaiByr = this.expPayment.obj.nilaiByr || 0;
        if (this.invalidExpPayment) {
            // console.log('validation expPayment : ', this.$v.expPayment.obj);
            // console.log('selected Exp : ',this.expPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
    //    } else if (this.expPayment.obj.nilaiByr>this.expPayment.obj.outstand){
       } else if ((this.expPayment.obj.nilaiByr-this.expPayment.obj.outstand) > 0.01){
            toastr.error('Payment Amount exceeds Outstanding Amount', "ERROR MESSAGE");
       } else {
            this.expPayment.obj.selisihKurs = this.expPayment.obj.nilaiBank - (this.expPayment.obj.nilaiByr * this.expPayment.obj.kursKeExp);
            for (var key in this.expPayment.obj) {
                this.expPayment.selected[key] = this.expPayment.obj[key];
            }
            this.calcTotalDtlPaym();
            this.expPayment.selected._showDetails=false;
            if (callback) callback();
            if (this.inputLineBerlanjut==1) {
                this.addExpPayment();
                this.$v.expPayment.obj.$reset();                        
            }                    

        }
    },
    onSelectLkuExp(invLookup) {
        this.lkuExpShow=false;
        this.lkuExpData=invLookup;
        const ada = this.expPayment.items.find(ap => ap.expenKey == invLookup.selected.expenKey);
        if (ada) {
            // if (ada.expPayKey!== this.expPayment.selected.expPayKey) {
                toastr.error(`ER Number ${invLookup.selected.nomor} already on paid list`,'ERROR MESSAGE',10000);
                return;
            // }
        }        

        this.expPayment.obj.expenKey=invLookup.selected.expenKey;
        this.expPayment.obj.nomor=invLookup.selected.nomor;
        this.expPayment.obj.dibayarke=invLookup.selected.dibayarke;
        this.expPayment.obj.keterangan=invLookup.selected.keterangan;
        this.expPayment.obj.crewkey=invLookup.selected.crewkey;
        this.expPayment.obj.crewinfo=invLookup.selected.crewinfo;
        this.expPayment.obj.matauang=invLookup.selected.matauang;
        this.expPayment.obj.jumlah=invLookup.selected.jumlah;
        this.expPayment.obj.outstand=invLookup.selected.outstand;
        this.expPayment.obj.nilaiByr=invLookup.selected.outstand;
        this.expPayment.obj.cashflow=invLookup.selected.cashflow;
        this.expPayment.obj.kodecash=invLookup.selected.kodecash;
        this.updateDimDtl2Hdr(invLookup.selected);
        if ((this.model.uraian || '') == '') {
            this.model.uraian=invLookup.selected.keterangan;
        }
        if ((this.model.terimadari || '') == '') {
            this.model.terimadari=invLookup.selected.crewinfo;
        }
        if ((this.model.cashflow || '') == '') {
            this.model.cashflow = this.expPayment.obj.cashflow;
            this.model.kodecash = this.expPayment.obj.kodecash;
            // this.model.namacash = this.expPayment.obj.namacash;
        }
        if (this.expPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.expPayment.obj.nilaiBank=invLookup.selected.outstand;
            this.expPayment.obj.kursKeExp = 1;
            this.expPayment.obj.selisihkurs = 0;
        }
        tranbank.byrsemuExp(invLookup.selected).then(result => {
                this.expPayment.obj.byr_semu= result.byr_semu;
                this.expPayment.obj.byr_semu_doc= result.byr_semu_doc;
            })
            .catch(err => {
                console.log('byrsemu Adv -> ', err);
            });
    },
    updateExppaym: function() {
        if (this.expPayment.obj.matauang.trim() == this.model.matauang.trim()) {
            this.expPayment.obj.nilaiBank=this.expPayment.obj.nilaiByr;
            this.expPayment.obj.kursKeExp = 1;
        }
    },

    closeOthPayment: function(){
        const opened= this.othPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOthPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true};
        this.othPayment.selected = obj;
        for (var key in this.othPayment.obj) {
            this.othPayment.obj[key] = '';
        }
        this.othPayment.obj.uraian=this.model.uraian;
        this.updateDimHdr2Dtl(this.othPayment.obj);
        this.othPayment.items.push(obj);
        this.othPayment.total=this.othPayment.items.length;
        setTimeout(() => {
            const bfore = this.othPayment.page;
            const after =Math.ceil((this.othPayment.total)/this.othPayment.limit);
            if (bfore != after){
                this.othPayment.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.othPayment.total} items`,'Detail OTHERS PAYMENT',10000);
            }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editOthPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.othPayment.selected = obj;
        for (var key in this.othPayment.obj) {
            this.othPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.othPayment.obj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.othPayment.obj[dim.value] = obj[dim.value];
                this.othPayment.obj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.othPayment.obj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.inputLineBerlanjut=0;
        callback();
    },
    delOthPayment: function (index) {
        if (!this.saveEnabled) return;
        if (index > -1) {
            // this.othPayment.items.splice(index, 1);
            const posisi = (this.othPayment.page-1)*this.othPayment.limit;
            this.othPayment.items.splice(posisi+index, 1);
        }
        this.othPayment.total=this.othPayment.items.length;
        this.calcTotalDtlPaym();
    },
    saveOthPayment: async function (callback) {
        this.othPayment.obj.umasuk = this.othPayment.obj.umasuk || 0;
        if (this.invalidOthPayment) {
            console.log('validation othPayment : ', this.$v.othPayment.obj);
            console.log('othPayment Object : ',this.othPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let datadim=this.othPayment.obj;
            datadim.TableName = 'trbankdtl';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.othPayment.obj) {
                        this.othPayment.selected[key] = this.othPayment.obj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.othPayment.selected[dim.value] = datadim[dim.value];
                            this.othPayment.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlPaym();
                    this.othPayment.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addOthPayment();
                        this.$v.othPayment.obj.$reset();                        
                    }                    
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE");
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                
            }
        }
    },
    onSelectLkuCoa(_selected) {
        this.othPayment.obj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.othPayment.obj.kodeacc = _selected.kodeacc;
        this.othPayment.obj.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },

    closeTranPayment: function(){
        const opened= this.tranPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addTranPayment : function () {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        const obj={_showDetails:true};
        this.tranPayment.selected = obj;
        for (var key in this.tranPayment.obj) {
            this.tranPayment.obj[key] = '';
        }
        this.tranPayment.items.push(obj);
        this.tranPayment.total=this.tranPayment.items.length;
        this.inputLineBerlanjut=1;
    },
    editTranPayment : function (obj,callback) {
        this.closeApPayment();
        this.closeAdvPayment();
        this.closeAdvSetPayment();
        this.closeExpPayment();
        this.closeTranPayment();
        this.closeOthPayment();
        this.tranPayment.selected = obj;
        for (var key in this.tranPayment.obj) {
            this.tranPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.tranPayment.obj[key] = obj[key];
        }
        this.inputLineBerlanjut=0;
        callback();
    },
    delTranPayment: function (index) {
        if (!this.saveEnabled) return;
        if (index > -1) {
        this.tranPayment.items.splice(index, 1);
        }
        this.tranPayment.total=this.tranPayment.items.length;
        this.calcTotalDtlPaym();
    },
    saveTranPayment: function (callback) {
        this.tranPayment.obj.valas_in = this.tranPayment.obj.valas_in || 0;
        this.tranPayment.obj.kurstrx = this.tranPayment.obj.kurstrx || 1 ;
        this.tranPayment.obj.nilaibank = this.tranPayment.obj.nilaibank || 0;
        if (this.model.matauang==this.uanguser) {
            this.tranPayment.obj.bank_in = this.tranPayment.obj.nilaibank;
        } else {
            this.tranPayment.obj.bank_in = parseFloat(this.tranPayment.obj.nilaibank) * parseFloat(this.tranPayment.obj.kurstrx);
        }
        if (this.invalidTranPayment) {
            console.log('validation tranPayment : ', this.$v.tranPayment.obj);
            console.log('tranPayment Object : ',this.tranPayment.obj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.tranPayment.obj) {
                this.tranPayment.selected[key] = this.tranPayment.obj[key];
            }
            this.calcTotalDtlPaym();
            this.tranPayment.selected._showDetails=false;
            if (callback) callback();
        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        this.apPayment.items.forEach((trx)=> {
            if (trx.apinvkey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.advPayment.items.forEach((trx)=> {
            if (trx.advanKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.expPayment.items.forEach((trx)=> {
            if (trx.expenKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.advSetPayment.items.forEach((trx)=> {
            if (trx.advSttlKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.othPayment.items.forEach((trx)=> {
            if (trx.kodeacc) totalDtlPaym = totalDtlPaym + parseFloat(trx.umasuk);
        });
        this.tranPayment.items.forEach((trx)=> {
            if (trx.kodebank2) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
    //   router.push({name:'treasury.trxlist'});
      if (this.$store.state.prevRoute.name) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'treasury.roplist'});
      }
    }
  }
};
</script>
